const plugins = {
  PageLeave: {
    heartbeat_interval_time: 3,
  },
  PageLoad: {},
}

export default plugins
